<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th id="commentdate" class="col-md-3 col-sm-6 ml-3">
              Fecha
            </th>
            <th id="commentdescription" class="col-md-6 col-sm-6">
              Comentario
            </th>
            <th id="commentaction" class="col-2 d-sm-none" />
          </tr>
        </thead>
        <tbody v-if="!isAddMode">
          <tr
            v-for="(comment, index) in comments"
            :key="index"
            class="row pl-2"
          >
            <td class="col-md-3 col-sm-12 text-left custom-column-separator">
              {{ comment.date | formatDate }}
            </td>
            <td
              class="col-md-6 col-sm-12 text-left custom-column-separator"
              :class="{ 'col-md-9': disabled }"
            >
              {{ comment.description }}
            </td>
            <td
              v-if="!disabled"
              class="col-md-3 col-sm-12 text-right action-button-left-spacing"
            >
              <button
                v-if="!disabled"
                class="btn btn-dropdown-actions dropdown-toggle pt-1 action-button-left-spacing"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a
                  class="drop-item cursor-pointer"
                  @click="editComment(comment)"
                >
                  <em class="fas fa-pencil-alt text-green pr-2" />
                  <span>Editar</span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="row">
            <td class="col-md-12">
              <div
                v-if="!isAddMode && comments.length > 0"
                class="text-right mr-n3"
              >
                <ActionButton
                  v-if="!disabled"
                  i="fas fa-file-plus"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                  :disabled="disabled"
                  @click="addComment"
                >
                  Añadir
                </ActionButton>
              </div>
              <div
                v-if="!isAddMode && comments.length == 0"
                class="text-center"
              >
                <button
                  class="btn bg-light-white w-50 pt-1 mt-2 button-add"
                  :disabled="disabled"
                  @click="addComment"
                >
                  <em class="fas fa-plus-square pr-4 text-green custom-icon" />
                  <span class="text-button-add-document">
                    Presione aquí para añadir información de seguimiento
                  </span>
                </button>
              </div>
              <TrackingInformationAdd
                v-if="isAddMode"
                :comment="comment"
                @on-save="onSaveTracking"
                @on-cancel="onCancelAddTracking"
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('$_student');
import TrackingInformationAdd from './TrackingInformationAdd';
import { ActionButton } from '@/components/common';
const GET_STUDENT_COMMENT_METHOD =
  'api/student/getstudentcommentsforselectedregistry?studentSie=';
const ADD_STUDENT_COMMENT_METHOD = 'api/student/addcommcomment';
const UPDATE_STUDENT_COMMENT_METHOD = 'api/student/updatecommcomment';
const CUSTOM_DATE_FORMAT = 'DD/MMMM/YYYY';

export default {
  name: 'InformationTracking',
  data() {
    return {
      comments: [],
      comment: null,
      isAddMode: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapGetters({
      selectedStudent: 'SelectedStudent',
      selectedPreRegistry: 'getStudentPreRegistry',
    }),
    studentSieId() {
      return parseInt(this.selectedStudent.studentId);
    },
    academyYearId() {
      return this.selectedPreRegistry.academicYearId;
    },
    regStudentId() {
      return this.selectedPreRegistry.regStudentId;
    },
  },
  filters: {
    formatDate: (date) => {
      return moment(date)
        .locale('es')
        .format(CUSTOM_DATE_FORMAT);
    },
  },
  methods: {
    async getAllStudentComments() {
      if (this.studentSieId) {
        const { data: comments } = await this.$ApiGet(
          `${GET_STUDENT_COMMENT_METHOD}${this.studentSieId}&regStudentId=${this.regStudentId}`
        );
        if (comments) {
          this.comments = comments;
        }
      }
    },
    async addStudentComment(info) {
      if (info && this.studentSieId && this.regStudentId) {
        const params = {
          date: new Date(info.date),
          description: info.description,
          studentSieId: this.studentSieId,
          academicYearId: this.academyYearId,
          regStudentId: this.regStudentId,
          deleteFlag: '0',
        };
        const { data: addResult } = await this.$ApiPost(
          ADD_STUDENT_COMMENT_METHOD,
          params,
          true
        );
        if (addResult) {
          this.isAddMode = false;
          this.getAllStudentComments(); //refresh list
        }
      }
    },
    async updateStudentComment(info) {
      if (info && this.selectedStudent) {
        const { data: updateResult } = await this.$ApiPut(
          UPDATE_STUDENT_COMMENT_METHOD,
          info,
          true
        );
        if (updateResult) {
          this.isAddMode = false;
          this.getAllStudentComments(); //refresh list
        }
      }
    },
    addComment() {
      this.comment = null;
      this.isAddMode = true;
    },
    editComment(info) {
      if (info) {
        this.comment = { ...info, date: new Date(info.date) };
        this.isAddMode = true;
      }
    },
    async onSaveTracking(info, isEditMode) {
      if (info) {
        if (!isEditMode) {
          await this.addStudentComment(info);
        } else {
          await this.updateStudentComment(info);
        }
      }
    },
    onCancelAddTracking() {
      this.isAddMode = false;
    },
  },
  async mounted() {
    await this.getAllStudentComments();
  },
  components: {
    ActionButton,
    TrackingInformationAdd,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.custom-icon {
  font-size: 17px;
}

.custom-column-separator {
  padding-left: 40px;
}

.action-button-left-spacing {
  padding-right: 75px;
}
</style>
